import { ACTION, MISCELLANEOUS_RESOURCES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermissionV2 } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Download invoice',
				id: 'download',
				isEnabled: () => {
					return hasPermissionV2({
						configPageName: PAGE_NAMES.miscellaneous,
						configResourceName: MISCELLANEOUS_RESOURCES.invoiceGeneration,
						configActionName: ACTION.generateInvoice
					});
				}
			}
		]
	};
};

export default {
	makeActionList
};
